import { useQuery } from '@apollo/react-hooks';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { getAGGClient } from '@confluence/graphql';
import { useSessionData } from '@confluence/session-data';

import {
	CONFLUENCE_STANDARD_OFFERING_KEY,
	FALLBACK_PRODUCT_UPGRADE_URL,
	HAMS_PRODUCT_KEY,
	RECOMMEND_TO_FREE_ANALYTICS_SOURCE,
	RECOMMEND_TO_FREE_STATSIG_EXPERIMENT,
} from '../package-constants';
import type { UpgradeStatusForFree } from '../graphql/__types__/UpgradeStatusForFree';
import { FetchUpgradeStatusForFree } from '../graphql/FetchUpgradeStatusForFreeQuery.agggraphql';

export const useFetchUpgradeStatusForFree = ({ skip }: { skip: boolean }) => {
	const { cloudId } = useSessionData();
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const offeringKey = CONFLUENCE_STANDARD_OFFERING_KEY;

	const { data } = useQuery<UpgradeStatusForFree>(FetchUpgradeStatusForFree, {
		client: getAGGClient(),
		variables: {
			cloudId,
			productKey: HAMS_PRODUCT_KEY,
			offeringKey,
		},
		skip,
		onError: (error) => {
			createAnalyticsEvent({
				type: 'sendOperationalEvent',
				data: {
					action: 'failed',
					actionSubject: 'confluenceRecommendToFreeExperiment',
					source: RECOMMEND_TO_FREE_ANALYTICS_SOURCE,
					attributes: {
						cloudId,
						flagKey: RECOMMEND_TO_FREE_STATSIG_EXPERIMENT,
						error,
						errorSource: 'FetchUpgradeStatusForFree',
					},
				},
			}).fire();
		},
	});

	const entitlement = data?.tenantContexts?.[0]?.entitlementInfo?.entitlement;

	const userCanUpgrade = !!entitlement?.experienceCapabilities?.changeOffering?.isAvailableToUser;
	const upgradeUrl =
		entitlement?.experienceCapabilities?.changeOffering?.experienceUrl ||
		FALLBACK_PRODUCT_UPGRADE_URL;

	return {
		userCanUpgrade,
		upgradeUrl,
	};
};
